<template>
  <div class="login-form-container">

    <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="login-form"
      @submit.prevent="handleSubmit">
      <el-alert v-if="isLoginError" type="error" :closable="false" show-icon style="margin-bottom: 24px;"
        :title="loginErrorMessage" />
      <el-alert v-if="isAuthError" type="error" :closable="false" show-icon style="margin-bottom: 24px;"
        :title="authErrorMessage" />
      <div class="login-header">
        <img src="@/assets/logo.png" alt="Logo" class="login-logo" />
        <h2 class="login-form-title"> 翼查通客户管理后台</h2>
      </div>
      <!-- 用户名输入 -->
      <el-form-item prop="username">
      
        <el-input v-model="loginForm.username" size="large" style="background-color: white;" type="text" placeholder="请输入用户名" :prefix-icon="User" />
      </el-form-item>

      <!-- 密码输入 -->
      <el-form-item prop="password">
        <el-input v-model="loginForm.password" size="large" style="background-color: white;" type="password" placeholder="请输入密码" show-password
          :prefix-icon="Lock" @keyup.enter="handleSubmit" />
      </el-form-item>

      <!-- 记住我 -->
      <el-form-item>
        <el-checkbox v-model="loginForm.rememberMe">
          记住我
        </el-checkbox>
      </el-form-item>

      <!-- 登录按钮 -->
      <el-form-item style="margin-top: 24px;">
        <el-button type="primary" size="large" class="login-button" :loading="state.loginBtn" :disabled="state.loginBtn"
          @click="handleSubmit">
          登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { User, Lock } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { login } from '@/api/login.js'

export default {
  name: 'LoginForm',
  components: {
    User,
    Lock
  },
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        rememberMe: false
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      isLoginError: false,
      isAuthError: false,
      loginErrorMessage: '用户名或密码错误',
      authErrorMessage: '您无权访问本系统',
      authErrorTimer: null,
      loginErrorTimer: null,
      state: {
        loginBtn: false
      }
    }
  },
  beforeUnmount() {
    // 清除所有未完成的定时器
    if (this.authErrorTimer) {
      clearTimeout(this.authErrorTimer)
    }
    if (this.loginErrorTimer) {
      clearTimeout(this.loginErrorTimer)
    }
  },
  methods: {
    // 表单提交处理
    handleSubmit() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          this.state.loginBtn = true
          const loginParams = {
            username: this.loginForm.username,
            password: this.loginForm.password
          }

          login(loginParams)
            .then(res => {
              this.loginSuccess(res)
            })
            .catch(err => {
              this.requestFailed(err)
            })
            .finally(() => {
              this.state.loginBtn = false
            })
        }
      })
    },

    // 登录成功处理
    loginSuccess(res) {
      const expireTime = new Date().getTime() + 24 * 60 * 60 * 1000
      const userData = {
        username: this.loginForm.username,
        expireTime: expireTime
      }
      localStorage.setItem('userData', JSON.stringify(userData))

      if (res && res.token) {
        localStorage.setItem('token', res.token)
      }

      this.$router.push({ path: '/' })
      setTimeout(() => {
        ElMessage.success({
          message: '欢迎',
          duration: 2000
        })
      }, 1000)
      this.isLoginError = false
      this.isAuthError = false
    },

    // 请求失败处理
    requestFailed(err) {
      // 清除之前的定时器（防止多次触发）
      if (this.authErrorTimer) {
        clearTimeout(this.authErrorTimer)
      }
      if (this.loginErrorTimer) {
        clearTimeout(this.loginErrorTimer)
      }

      const errMessage = err?.message || err?.response?.data?.message || '登录失败'

      if (errMessage.includes('您无权访问本系统')) {
        // 当同时触发时，关闭用户名密码提示
        this.isAuthError = true
        this.isLoginError = false

        this.authErrorTimer = setTimeout(() => {
          this.isAuthError = false
        }, 3000)
        return
      } else if (errMessage.includes('用户名密码错误')) {
        // 当同时触发时，关闭权限访问提示
        this.isAuthError = false
        this.isLoginError = true
        this.loginErrorTimer = setTimeout(() => {
          this.isLoginError = false
        }, 3000)
        return
      } else {
        // 其他错误
        ElMessage.error({
          message: errMessage,
          duration: 3000
        })
      }
    }
  }
}
</script>

<style scoped>
.login-form-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
}

.login-form-title {
  color: rgba(0, 0, 0, .85);
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
}

.login-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  gap: 12px;
}

.login-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.login-form {
  width: 100%;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.95);
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.login-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
}

:deep(.el-form-item__label) {
  font-size: 14px;
}

:deep(.el-input__wrapper) {
  background-color: white !important;
}

:deep(.el-input__inner) {
  background-color: white !important;
}
</style>
